import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../util/Helpers";
import {
  NAVY,
  MUTED,
  HAIRLINE,
  SectionLabel,
  InfoRow,
  PrimaryButton,
  IconCheck,
  displayFont,
} from "../FlightFinalOffer/ui";

// Paid + ticketed state for a held fare.
const Page4 = ({ trans }: { trans: any }) => {
  const navigate = useNavigate();
  const pnr =
    trans?.metadata?.flightBooking?.providerRef ||
    trans?.metadata?.flightHold?.providerRef ||
    trans?.providerBookingRef;

  return (
    <div className="max-w-[640px] mx-auto">
      <div className="co-card p-6 md:p-8 mb-4 text-center">
        <div
          className="mx-auto mb-5 flex items-center justify-center"
          style={{
            width: 68,
            height: 68,
            borderRadius: 999,
            background: "rgba(34,197,94,.12)",
            animation: "co-pop-in .5s cubic-bezier(.34,1.56,.64,1) .1s both",
          }}
        >
          <IconCheck size={30} color="#16A34A" />
        </div>
        <h2 style={{ fontFamily: displayFont, fontSize: 24, fontWeight: 700, color: NAVY, marginBottom: 6 }}>
          Your flight is booked
        </h2>
        <p style={{ color: MUTED, fontSize: 15 }}>
          Payment received and ticket issued. We've emailed the details to{" "}
          <span style={{ color: NAVY, fontWeight: 600 }}>{trans?.email || "you"}</span>.
        </p>
      </div>

      <div className="co-card p-5 md:p-6 mb-4">
        <SectionLabel>Booking details</SectionLabel>
        <div
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: NAVY,
            paddingBottom: 14,
            borderBottom: `1.5px solid ${HAIRLINE}`,
            marginBottom: 14,
          }}
        >
          {trans?.description || "Your flight"}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <InfoRow icon={<IconCheck />} label="Airline PNR" value={pnr || "-"} />
          <InfoRow icon={<IconCheck />} label="Booking reference" value={trans?.systemRef} />
          <InfoRow
            icon={<IconCheck />}
            label="Amount paid"
            value={formatCurrency(Number(trans?.amount) || 0, trans?.currency)}
          />
          <InfoRow icon={<IconCheck />} label="Email" value={trans?.email || "-"} />
        </div>
      </div>

      <PrimaryButton onClick={() => navigate("/flights")}>Book another flight</PrimaryButton>
    </div>
  );
};
export default Page4;
